import Chip from '@ui/Chip';
import Link from '@ui/Link';
import Typography from '@ui/Typography';
import { getEndsInText } from '@utils/dateHelpers';
import {
  getCrowdFundingLink,
  getPostImage,
  getPostLink,
} from '@utils/post.helper';
import React from 'react';
import ActionBar from './ActionBar';
import NonProfitCauses from './NonProfitCauses';
import PostAuthorProfile from './PostAuthorProfile';
import PostImage from './PostImage';
import PostVideo from './PostVideo';
import PostMessage from './PostMessage';
import ReactionBar from './ReactionBar';
import PostTypeIndicatorChip from './PostTypeIndicatorChip';
import TrackPostVisibility from '../TrackPost/trackPostVisibility';
import NonProfitProfileBar from './NonProfitProfileBar';
import CrowdFundingGivingLevels from './CrowdFundingGivingLevels';
import ContributionProgress from './ContributionProgress';
import FundraisingOrgProfileBar from './FundraisingOrgProfileBar';
import PostImageLink from './PostImageLink';

function CrowdFundingPostBody(props) {
  const { post, type, home } = props;
  const { sourcePostData } = post;
  const fundraisingOrg = post.renderProps.fundraisingOrg;

  const { title, message, endDate, beneficiary } = sourcePostData;

  const endsInDaysText = getEndsInText(endDate);

  const hasImage = getPostImage(post);
  const hasVideo = post.renderProps.videoUrls && post.renderProps.videoUrls[0];
  const postLink = getPostLink(post);

  return (
    <TrackPostVisibility post={post} type={type}>
      <div>
        <div className="divide-y px-6 lg:px-4">
          <div className="flex flex-col gap-4 py-6 lg:py-4">
            {/* {nonProfit && nonProfit.causes && (
              <NonProfitCauses
                nonProfit={nonProfit}
                className="border-b pb-4"
              />
            )} */}

            <PostAuthorProfile post={post} home={home} />
          </div>

          <div className="flex w-full flex-col items-start justify-between gap-2 py-2 lg:flex-row">
            <Link href={postLink}>
              <Typography
                variant="h5"
                className="flex-1 group-hover:text-text-hyperlink">
                {title}
              </Typography>
            </Link>
            <div className="flex w-full items-center justify-between gap-2 lg:w-auto lg:flex-col lg:items-end">
              <PostTypeIndicatorChip
                postType={post.sourcePostType}
                crowdFundType={beneficiary?.beneficiaryType}
              />
              <Typography
                variant="caption"
                color="textSecondary"
                className="whitespace-nowrap">
                {endsInDaysText}
              </Typography>
            </div>
          </div>
        </div>

        {hasVideo ? <PostVideo post={post} /> : <PostImageLink post={post} />}

        {fundraisingOrg && (
          <FundraisingOrgProfileBar
            fundraisingOrg={fundraisingOrg}
            post={post}
          />
        )}

        <div className="flex items-start px-6 py-4 lg:items-center lg:px-4">
          <ContributionProgress post={post} />
        </div>
        <div className="flex w-full justify-between gap-2">
          <CrowdFundingGivingLevels
            post={post}
            className="flex-1 overflow-hidden"
            paddingClass="px-6 lg:px-4"
          />
        </div>
        <div className="flex flex-col gap-6 px-6 lg:px-4">
          <div className="divide-y">
            <div className="py-2">
              <PostMessage message={message} />
            </div>

            <ReactionBar post={post} />

            <div className="flex justify-center py-2">
              <ActionBar post={post} />
            </div>
          </div>
        </div>
      </div>
    </TrackPostVisibility>
  );
}

export default CrowdFundingPostBody;
